const deps = ['$stateParams', 'AddOnCollection'];

const AddonSelectCtrl = function ($stateParams, AddOnCollection) {
  let adjustedLength, array, day;
  this.$stateParams = $stateParams;
  (array = $stateParams.date.split('-')),
    (adjustedLength = Math.max(array.length, 1)),
    ([this.month, day] = Array.from(array.slice(0, adjustedLength - 1))),
    (this.year = array[adjustedLength - 1]);

  const addons = new AddOnCollection($stateParams.clientId);

  this.addons = addons.$listen(addons);
};

AddonSelectCtrl.$inject = deps;

module.exports = AddonSelectCtrl;
